import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthService from 'service/AuthService';
import { loginSuccess } from 'action/AuthAction';

const Gate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sId = searchParams.get("sId");
  
  const { sessionId } = useSelector((state: any) => state.auth);

  const [error, setError] = React.useState<string>("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authService = AuthService();

  // http://localhost:3000/?sId=RQKjozJiUh
  const decodeFormSession = async () => {
    console.log("Gate sessionId:", sessionId);
    console.log("Gate sId:", sId);
    console.log("Gate sessionId === sId:", sessionId === sId);
    if (sessionId === sId) {
      navigate('/intro?sId=' + sId);
      return;
    }

    try {
      const res = await authService.decodeFormWeb(sId as string);
      console.log("sessionId aoidjwaoijdoiawjoidjoiwad => " + sId)
      dispatch(loginSuccess({ token: res.data.token, profile: res.data, sessionId: sId }))
      navigate('/intro?sId=' + sId);
    } catch (error) {
      console.error('Decode Error:', error);
      setError(error as string);
    }
  };

  useEffect(() => {
    console.log('Gate sessionId:', sId);
    if (sId) {
      decodeFormSession()
    } else {
      alert('Invalid Access');
    }
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <p>{error}</p>
    </div>
  );
};

export default Gate;